import { render } from "./EmberView.vue?vue&type=template&id=1fa676d1"
import script from "./EmberView.vue?vue&type=script&lang=js"
export * from "./EmberView.vue?vue&type=script&lang=js"

import "./EmberView.vue?vue&type=style&index=0&id=1fa676d1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__